import bookSummary from './bookSummary';

export default bookSummary;